<div class="modal">
  <div class="modal-header header">
    <button
      *ngIf="mode === NotificationEnum.Contract"
      class="btn-icon header-back fade-in"
      (click)="mode = NotificationEnum.Status"
    >
      <app-svg-icon
        src="../../../../assets/icons/chevron-left.svg"
        color="black"
        width="15px"
        height="15px"
      >
      </app-svg-icon>
    </button>
    <span class="header-title">Notificações</span>
    <button
      *ngIf="mode === NotificationEnum.Status"
      class="btn-icon header-reload d-flex align-center justify-center fade-in"
      matTooltip="Atualizar notificações"
      (click)="reloadNotifications()"
    >
      <app-svg-icon
        src="assets/icons/reload-icon.svg"
        width="14px"
        height="14px"
        color="black"
      ></app-svg-icon>
    </button>
    <button
      class="btn-icon header-close d-flex align-center justify-center"
      (click)="closeNotifications()"
    >
      <app-svg-icon
        src="assets/icons/close-icon.svg"
        width="18px"
        height="18px"
        color="black"
      ></app-svg-icon>
    </button>
  </div>
  <div class="modal-body body">
    <ng-container [ngSwitch]="mode">
      <div
        class="fade-in body-status status row direction-column p-10"
        *ngSwitchCase="NotificationEnum.Status"
      >
        <div
          class="status-card card row align-center p-5"
          [matBadgeHidden]="
            Number(statusNotification[NotificationType.CancelCompany].badgeNumber) < 1
          "
          [matBadge]="
            statusNotification[NotificationType.CancelCompany].badgeNumber
          "
          matBadgeSize="medium"
          role="button"
          tabindex="0"
          (click)="handlerContracts(NotificationType.CancelCompany)"
          (keydown.enter)="handlerContracts(NotificationType.CancelCompany)"
          (keydown.space)="handlerContracts(NotificationType.CancelCompany)"
        >
          <span class="card-title">{{
            statusNotification[NotificationType.CancelCompany].label
          }}</span>
        </div>

        <div
          class="status-card card row align-center p-5"
          [matBadgeHidden]="
            Number(statusNotification[NotificationType.CancelContract].badgeNumber) < 1
          "
          [matBadge]="
            statusNotification[NotificationType.CancelContract].badgeNumber
          "
          matBadgeSize="medium"
          role="button"
          tabindex="0"
          (click)="handlerContracts(NotificationType.CancelContract)"
          (keydown.enter)="handlerContracts(NotificationType.CancelContract)"
          (keydown.space)="handlerContracts(NotificationType.CancelContract)"
        >
          <span class="card-title">{{
            statusNotification[NotificationType.CancelContract].label
          }}</span>
        </div>
      </div>
      <div
        class="fade-in body-contract contract row direction-column p-10"
        *ngSwitchCase="NotificationEnum.Contract"
      >
        <ng-container *ngIf="currentContracts.length > 0">
          <div
            class="contract-card card row align-center justify-space-between ptb-5 pl-10"
            *ngFor="let contract of currentContracts"
          >
            <span class="card-title"> {{ contract.ContractNumber }}</span>
            <button
              class="card-btn d-flex align-center justify-center"
              (click)="handlerContractDetails(contract.ContractNumber)"
            >
              <app-svg-icon
                src="assets/icons/view-icon.svg"
                width="13px"
                height="13px"
                color="white"
              ></app-svg-icon>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="currentContracts.length === 0">
          <div class="contract-card card row align-center justify-center">
            <span class="card-empty">Não há notificações</span>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <div
      *ngIf="showLoader"
      class="body-loader loader d-flex justify-center align-center"
    >
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
</div>
